import { useInView } from "react-intersection-observer"
import * as styles from "./styles.module.scss"
import Button from "components/Button"
import cx from "classnames"
import Link from "gatsby-link"
import * as React from "react"

export interface TextImageBlockProps {
  cta?: string
  ctaLink?: string
  eyebrow?: string
  heading: string
  imgAlt: string
  imgSrcLarge: string
  imgSrcLargeWidth: string
  imgSrcSmall: string
  imgSrcSmallWidth: string
  picturePosition: "left" | "right"
  subhead: string | React.ReactNode
}

const TextImageBlock: React.FC<TextImageBlockProps> = ({
  cta,
  ctaLink,
  eyebrow,
  heading,
  imgAlt,
  imgSrcLarge,
  imgSrcLargeWidth,
  imgSrcSmall,
  imgSrcSmallWidth,
  picturePosition = "left",
  subhead,
}) => {
  const [ref, inView] = useInView()

  return (
    <section
      className={cx({
        [styles.textImageBlock]: true,
        [styles[picturePosition]]: picturePosition,
        [styles.inView]: inView,
      })}
      ref={ref}
    >
      <div className={styles.pagePadding}>
        <div className={styles.figureWrapper}>
          <div className={styles.figureCircle}>
            <figure className={styles.figure}>
              <img
                className={styles.image}
                src={imgSrcSmall}
                alt={imgAlt}
                srcSet={`${imgSrcLarge} ${imgSrcLargeWidth}, ${imgSrcSmall} ${imgSrcSmallWidth}`}
                sizes="25vw"
              />
            </figure>
          </div>
        </div>
        <div className={styles.message}>
          <div className={styles.header}>
            {eyebrow && <h6 className={styles.eyebrow}>{eyebrow}</h6>}
            <h2 className={styles.heading}>{heading}</h2>
          </div>
          <div className={styles.body}>
            <p className={styles.paragraph}>{subhead}</p>
          </div>
          {cta && ctaLink && (
            <div className={styles.actions}>
              <Link to={ctaLink}>
                <Button type="primary" size="lg" halo={true}>
                  {cta}
                </Button>
              </Link>
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

export default TextImageBlock
